import moment from 'moment';
import timezones from 'timezones.json';

// the file contains utility functions related to the project
export const desc = (a: any[], b: any[], orderBy: any) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const stableSort = (array: any[], cmp: any) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};

export const getSorting = (order: string, orderBy: string) => {
  return order === 'desc'
    ? (a: any, b: any) => desc(a, b, orderBy)
    : (a: any, b: any) => -desc(a, b, orderBy);
};

// extract unique keys from the list
export const getUniqueList = (arr: string[] | number[]) => {
  const result: any[] = [];
  for (const i in arr) {
    if (result.indexOf(arr[i]) === -1) {
      result.push(arr[i]);
    }
  }
  return result;
};

// extract unique keys from the list of objects
export const getUniqueListFromObject = (arr: any[], key: string) => {
  const result: string[] = [];
  for (const i in arr) {
    if (arr[i][key] && result.indexOf(arr[i][key]) === -1) {
      result.push(arr[i][key]);
    }
  }
  return result;
};

// export const setAuthorizationToken = (token: string) => {
//   if (token.length !== 0) {
//     axios.defaults.headers.common.Authorization = token;
//   } else {
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

export const updateObject = (state: any, updatedState: any) => {
  return {
    ...state,
    ...updatedState
  };
};
export const isEmpty = (obj: any) => {
  if (obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  } else {
    return false;
  }
};

export const secToHHMMDD = (sec: number | string): string => {
  if (!sec) {
    return '';
  }
  let seconds = parseInt(sec as string, 10);
  // var days = Math.floor(seconds / (3600*24));
  // seconds  -= days*3600*24;
  const hrs = Math.floor(seconds / 3600);
  seconds -= hrs * 3600;
  const mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;
  return (
    (hrs < 10 ? '0' + hrs : hrs) +
    ':' +
    (mnts < 10 ? '0' + mnts : mnts) +
    ':' +
    (seconds < 10 ? '0' + seconds : seconds)
  );
};

export const rowIndicators = {
  PINK: '#9c333c', // escalated
  RED: '#780211', // escalate
  YELLOW: '#ae6009', // resolve
  BROWN: '#824500' // time lapsed
};

export const ingestStatesIndicators = {
  ESCALATED: rowIndicators.PINK,
  ESCALATE: rowIndicators.RED,
  TIME_LAPSED: rowIndicators.BROWN
};

export const ingestActions = {
  ESCALATE: 'ESCALATE',
  TIME_LAPSED: 'TIME LAPSED',
  ESCALATED: 'ESCALATED',
  RESOLVE: 'RESOLVE'
};

export const ScreenType = {
  INGEST: 'ingest',
  PLAYLIST: 'playlist',
  PLAYOUT: 'playout'
};

export const PlaylistType = {
  NORMAL: 'normal',
  BREAK: 'break'
};

export const UserRoles = {
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  OPERATOR: 'operator'
};

// export const SKYNET_STATUS = {
//   escalate : ESCALATED,
//   FAILED,
//   SLA_VIOLATED,
//   PENDING,
//   SNOOZED,
//   STATE,
//   IGNORED
// }

export enum SKYNET_STATES {
  FAILED = 'failed',
  SUCCESS = 'success',
  PENDING = 'pending',
  WARNING = 'warning',
  SLA_VIOLATED = 'sla_violated',
  IGNORED = 'IGNORED',
  SNOOZED = 'SNOOZED',
  STALE = 'STATE'
}

export const getStatusId = (status: string) => {
  switch (status) {
    case SKYNET_STATES.FAILED:
      return 100; // no special use of choosing 100, just another higher number
    case SKYNET_STATES.SLA_VIOLATED || SKYNET_STATES.WARNING:
      return 99;
    case SKYNET_STATES.PENDING:
      return 97;
    case SKYNET_STATES.SNOOZED:
      return 98;
    default:
      return 1;
  }
};
export function LightenDarkenColor(col, amt) {
  let usePound = false;

  if (col[0] === '#') {
    col = col.slice(1);
    usePound = true;
  }

  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
}
export enum ConfirmationTypes {
  ESCALATE,
  SNOOZE,
  RESOLVE,
  DELETE_SCREEN,
  DELETE_USER,
  NONE
}

export const initialConfirmationState = {
  open: false,
  onCloseDialog: () => null,
  onProceedDialog: () => null,
  content: '',
  title: '',
  type: ConfirmationTypes.NONE
};

export const getTimezones = () => {
  let tZones = [];
  timezones.map(timezone => (tZones = tZones.concat(timezone.utc)));
  tZones.sort();
  return tZones;
};

export const formatDateTime = (
  dateTime: string,
  timeZone = 'UTC',
  format = 'YYYY-MM-DD hh:mm:ss (Z)'
) => {
  const momentDateTime = moment(dateTime);
  if (!timeZone) {
    timeZone = 'UTC';
  }
  if (!dateTime && !momentDateTime && !momentDateTime.isValid()) {
    return undefined;
  } else {
    return momentDateTime.tz(timeZone).format(format);
  }
};

export const prioritiesToEscalate: string[] = ['P1', 'P2', 'P3', 'P4'];
